(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/assets/javascripts/router.js');
'use strict';

const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints;
const _svs$components$lbUi$ = svs.components.lbUi.modal,
  ModalPortal = _svs$components$lbUi$.ModalPortal,
  ModalHidden = _svs$components$lbUi$.ModalHidden;
const NavContextProvider = svs.oddset_kambi.components.nav_context.NavContextProvider;
const setHeaderImageAltText = svs.components.lbUtils.setMetaTags.setHeaderImageAltText;
const CampaignFlerp = svs.components.lbUi.campaignFlerp.CampaignFlerp;
const isOddsmindChatLoaded = svs.oddset_kambi.data.isOddsmindChatLoaded;
const OddsmindChatReactComponent = svs.oddset_kambi.components.oddsmind_chat.OddsmindChatReactComponent;
const isInTarget = svs.components.targeting.isTargeted('oddset_oddsmind', 'B');
const displayOddsmindChat = svs.core.detect.feature('ft-oddsmind-chat') && isOddsmindChatLoaded && !isSelfService;
const _ReactRouterDOM = ReactRouterDOM,
  Router = _ReactRouterDOM.BrowserRouter,
  Route = _ReactRouterDOM.Route,
  Switch = _ReactRouterDOM.Switch;
const _svs$oddset_kambi = svs.oddset_kambi,
  _svs$oddset_kambi$pag = _svs$oddset_kambi.pages,
  PlayPage = _svs$oddset_kambi$pag.PlayPage,
  GameGuidePage = _svs$oddset_kambi$pag.GameGuidePage,
  WidgetPage = _svs$oddset_kambi$pag.WidgetPage,
  _svs$oddset_kambi$com = _svs$oddset_kambi.components,
  OddsetNavMenu = _svs$oddset_kambi$com.nav_menu.OddsetNavMenu,
  SeoArticles = _svs$oddset_kambi$com.seo_articles.SeoArticles;
const MenuTabTypes = svs.oddset_kambi.components.common.constants.MenuTabTypes;
const getPageComponent = tabType => {
  switch (tabType) {
    case MenuTabTypes.Play:
      return PlayPage;
    case MenuTabTypes.GameGuide:
      return GameGuidePage;
    case MenuTabTypes.Widget:
    default:
      return WidgetPage;
  }
};
const OddsetRouter = () => {
  var _svs$oddset_kambi$dat, _svs, _svs$oddset_kambi$dat2, _svs2;
  const routes = (_svs$oddset_kambi$dat = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.oddset_kambi) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.tabsConfig) !== null && _svs$oddset_kambi$dat !== void 0 ? _svs$oddset_kambi$dat : [];
  const routePlay = (_svs$oddset_kambi$dat2 = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.oddset_kambi) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 ? void 0 : _svs2.tabsConfigPlay) !== null && _svs$oddset_kambi$dat2 !== void 0 ? _svs$oddset_kambi$dat2 : {};
  const isSmallScreen = useMediaQuery(breakpoints.down(1080)); 

  const renderMobileMenu = !isSelfService && isSmallScreen;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const classNames = [renderMobileMenu ? 'oddset-bg-layer--mobile' : 'oddset-bg-layer--desktop', isSelfService ? 'oddset-bg-layer--selfservice' : '', isLoggedIn ? 'oddset-bg-layer--logged-in' : ''];
  return React.createElement(Router, {
    basename: svs.core.data.baseUrl
  }, displayOddsmindChat && isInTarget && React.createElement(OddsmindChatReactComponent, {
    isSmallScreen: isSmallScreen
  }), React.createElement(NavContextProvider, null, React.createElement(ModalPortal, null, React.createElement(ModalHidden, null, React.createElement("div", {
    className: "oddset oddset-bg-layer ".concat(classNames.join(' '))
  }, React.createElement(CampaignFlerp, null), React.createElement(OddsetNavMenu, {
    activeRoutes: routes,
    playRoute: routePlay,
    renderMobileMenu: renderMobileMenu
  }), React.createElement("div", {
    className: "oddset-content".concat(renderMobileMenu ? ' oddset-content--mobile' : '')
  }, React.createElement(Switch, null, routes.filter(route => !route.isPlayRoute).map(route => React.createElement(Route, {
    key: route.path,
    path: "/".concat(route.path),
    render: () => {
      const Component = getPageComponent(route.tabType);
      setHeaderImageAltText((route === null || route === void 0 ? void 0 : route.logotypeAltText) || "Oddset - ".concat(route.label));
      return React.createElement(Component, {
        widgetAreaIndex: route.widgetArea
      });
    }
  })), React.createElement(Route, {
    key: "playpage",
    path: [routePlay.path, ...routes.filter(route => route.isPlayRoute).map(route => route.path)],
    render: () => React.createElement(PlayPage, null)
  }))), React.createElement("div", {
    id: "KambiBC"
  })), React.createElement(SeoArticles, null)))));
};
setGlobal('svs.oddset_kambi.OddsetRouter', OddsetRouter);

 })(window);